import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadBrendi: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"BRENDI"} title={"Importar catálogo Brendi"}
  instructions={"Copie a URL do cardápio digital da sua loja na Brendi."}
  placeholder={"https://menu.brendi.com.br/sua-loja"} />;

export default UploadBrendi;
